<template>
  <CRow>
    <CCol sm="12" md="12">
      <CRow class="mt-3">
        <template v-if="messages.length">
          <transition name="fade">
            <MenssageAlert :messages="messages" />
          </transition>
        </template>
        <template>
          <CCol sm="12">
            <template v-if="isEmail">
              <CCol sm="12" class="p-0">
                <h2 class="h1 mb-4">{{ $t('auth.confirmRegister.header2.check-email') }}</h2>
              </CCol>
              <p class="h4 font-weight-normal d-flex align-items-center">
                <i class="cil-envelope-closed icon-custom-size mr-2 font-5xl text-primary pb-2"> </i>
                {{ $t('auth.confirmRegister.text.sent-email') }} {{ email }}
              </p>
              <div>
                <p class="h5 font-weight-normal text-gray-700 my-3">
                  {{ $t('auth.confirmRegister.text.receive-email') }}
                </p>
                <a @click="resend" class="h5 font-weight-normal mt-3 mb-2 btn-link text-underline">{{
                  $t('auth.confirmRegister.link.resend-email')
                }}</a>
              </div>
            </template>

            <template v-else>
              <p class="h4 font-weight-normal d-flex align-items-center">
                <i class="cil-phone icon-custom-size mr-2 font-5xl text-primary pb-2"> </i>
                {{ $t('auth.confirmRegister.text.sent-sms') }} + {{ phoneCountryIndicator + ' ' + phoneNumber }}
              </p>
              <div class="my-3">
                <p class="h5 font-weight-normal text-gray-700">
                  {{ $t('auth.confirmRegister.text.problem-email') }}
                </p>
                <p class="h font-weight-normal text-gray-700">
                  {{ $t('auth.confirmRegister.text.send-phone') }}
                </p>
              </div>

              <div>
                <a class="h5 font-weight-normal text-underline cursor-pointer text-gray-800" @click="sendCodeForPhone()">
                  {{ $t('auth.confirmRegister.text.send-token') }}
                </a>
              </div>
            </template>
          </CCol>
          <CCol sm="12" md="5" class="mt-4">
            <CInput
              class="mb-1"
              type="text"
              v-model.trim="$v.validationCode.$model"
              :isValid="checkIfValid('validationCode')"
              :invalidFeedback="$t('auth.confirmRegister.input.invalidFeedback.validationCode')"
              id="validationCode"
              aria-describedby=""
              :placeholder="$t('auth.confirmRegister.input.insert-token')"
            />
          </CCol>

          <CCol sm="12" md="12" class="mt-5">
            <!-- <CRow>
              <CCol sm="12" md="12" class="mt-4">
                
              </CCol>
            </CRow> -->
            <CButton class="mr-5" @click="() => $router.push({ name: 'Login' })">
              <CIcon name="cilArrowLeft" size="custom-size" :height="25" viewBox="0 0 32 32" />
              {{ $t('auth.newRegister.button.backToLogin') }}
            </CButton>
            <CButton :disabled="this.$v.validationCode.$invalid || submitted" type="submit" @click="confirm" color="primary" class="px-5">
              {{ $t('auth.confirmRegister.button.finish') }}
            </CButton>
          </CCol>
          <CCol sm="12" class="my-5" v-if="!isEmail">
            <CRow>
              <CCol sm="12" v-if="getSupport">
                <h4 class="h5 font-weight-normal mt-1">{{ $t('auth.confirmRegister.text.sent-to-our-support') }}</h4>
                <p class="h6 font-weight-normal text-gray-700">{{ $t('auth.confirmRegister.text.we-will-get-in-touch-with-you') }}</p>
              </CCol>

              <CCol sm="12" v-else>
                <h4 class="h5 font-weight-normal text-gray-700 mt-1">{{ $t('auth.confirmRegister.text.not-receiving-the-token') }}</h4>
                <a class="h5 font-weight-normal text-gray-700 text-underline cursor-pointer" @click.prevent="sendTicketSupport">
                  {{ $t('auth.confirmRegister.text.contact-support') }}
                </a>
              </CCol>

              <CCol sm="12" class="mt-3">
                <router-link class="font-weight-normal text-gray-700 text-underline cursor-pointer" :to="{ name: 'Login' }">
                  {{ $t('auth.confirmRegister.text.back') }}
                </router-link>
              </CCol>
            </CRow>
          </CCol>
        </template>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import { CallingCodeMoreFlag } from '@/utils/countriesUtils.js'
import MenssageAlert from '@/components/MenssageAlert'
import services from '@/services.js'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
export default {
  name: 'ConfirmRegister',
  components: {
    MenssageAlert,
  },
  data() {
    return {
      messages: [],
      loading: false,
      email: this.$store.getters['auth/emailUser'],
      userId: null,
      text: {
        status: null,
        text: '',
      },
      user: {
        email: '',
        phone: '',
      },
      qntResendEmail: 0,
      validationCode: '',
      submitted: false,
      phoneCountryIndicator: '',
      phoneNumber: '',
      getSupport: false,
    }
  },

  mixins: [validationMixin],
  validations: {
    validationCode: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(6),
    },
    phoneCountryIndicator: {
      required,
      minLength: minLength(2),
    },
    phoneNumber: {
      required,
      maxLength: maxLength(255),
    },
  },
  computed: {
    isValid() {
      return !this.$v.$invalid
    },
    isEmail: function () {
      return this.qntResendEmail <= 3
    },
    optionsCountries() {
      return CallingCodeMoreFlag(this)
    },
  },
  mounted() {
    let newRegister = this.$store.state.auth.newRegister

    if (!newRegister.userId) {
      this.$router.push({ name: 'Login' })
    }

    this.userId = newRegister.userId

    if (this.userId) {
      this.getDatauser(this.userId)
    }
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },

    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    resend() {
      this.messages = []

      this.loading = true
      let form = {
        id: this.userId,
      }

      services
        .requestEmailCode(form)
        .then(() => {
          this.messages = []

          this.messages.push({
            status: 'success',
            text: 'Check your email',
          })
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message || error.response.data.Message,
          })
        })
        .finally(() => {
          this.qntResendEmail = this.qntResendEmail + 1
          this.loading = false
        })
    },

    confirm() {
      this.messages = []

      this.loading = true
      if (this.$v.validationCode.$invalid) {
        return
      }

      let form = {
        id: this.userId,
        validationCode: Number(this.validationCode),
      }

      if (this.isEmail) {
        services
          .confirmEmail(form)
          .then((response) => {
            this.messages = []

            if (response.data.success) {
              this.messages.push({
                status: 'success',
                text: this.$t('auth.confirmRegister.messages.acount-active'),
              })

              this.loading = false

              setTimeout(() => {
                this.$router.push({ name: 'Login' })
              }, 1000)
            }
          })
          .catch(() => {
            this.messages.push({
              status: 'danger',
              text: this.$t('auth.confirmRegister.messages.wrong-code'),
            })
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        services
          .confirmPhoneNumber(form)
          .then((response) => {
            this.messages = []

            if (response.data.success) {
              this.messages.push({
                status: 'success',
                text: this.$t('auth.confirmRegister.messages.active-account'),
              })

              setTimeout(() => {
                this.$router.push({ name: 'Login' })
              }, 1000)
            }
          })
          .catch(() => {
            this.messages.push({
              status: 'danger',
              text: this.$t('auth.confirmRegister.messages.wrong-code'),
            })
          })
          .finally(() => {
            this.loading = false
          })
      }
    },

    sendTicketSupport() {
      this.messages = []
      let form = {
        id: this.userId,
        origin: 'Not_Receive_The_Token',
      }

      services
        .contactSupport(form)
        .then((response) => {
          if (response.data.success) {
            // setTimeout(() => {
            //   this.$router.push({ name: 'Login' })
            // }, 1000)
          }
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
        .finally(() => {
          this.getSupport = true
        })
    },

    sendCodeForPhone(newNumber = false) {
      this.messages = []

      let form = {
        id: this.userId,
      }

      if (newNumber) {
        this.$v.phoneCountryIndicator.$touch()
        this.$v.phoneNumber.$touch()

        if (this.$v.phoneCountryIndicator.$invalid || this.$v.phoneNumber.$invalid) {
          return
        }

        form.phoneCountryIndicator = this.phoneCountryIndicator.value
        form.phoneNumber = this.phoneNumber
      }

      this.loading = true
      services
        .requestPhoneCode(form)
        .then(() => {
          this.messages.push({
            status: 'success',
            text: this.$t('auth.confirmRegister.messages.check-your-phone'),
          })
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    getDatauser(userId) {
      this.messages = []
      this.loading = true

      services
        .getBasicInfo(userId)
        .then(({ data }) => {
          const { email, phoneNumber, phoneCountryIndicator } = data.data

          this.phoneCountryIndicator = phoneCountryIndicator
          this.phoneNumber = phoneNumber
          this.email = email
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.message,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss">
.btn-link {
  cursor: pointer;
}

.cursor-pointer:hover {
  cursor: pointer;
}
</style>
